import { Link, Typography } from '@packages/shared';
import { useIntl } from 'react-intl';
import { getValidImageExtension } from '../../helpers/getValidImageExtension';
import { seoimageLinkMessages } from './messages';

export type SeoImageLinkProps = {
  /**
   * <p>image source of the main product image</p>
   */
  imgSrc: string;
  /**
   * <p>seo relevant extension string to be appended on image src</p>
   * <i>e.G.: samsung-ue55ru7379-curved-led-fernseher-138-cm-55-zoll-4k-ultra-hd</i>
   */
  slug: string;
  /**
   * <p>the name of the product - displayed as link-text</p>
   */
  productName: string;
};

/**
 * <p>This is the seo image link component.</p>
 * <p>It renders a link to the main product image for SEO purposes.</p>
 * */
export const SeoImageLink = ({ imgSrc, slug, productName }: SeoImageLinkProps) => {
  const { formatMessage } = useIntl();
  const imageExtension = getValidImageExtension(imgSrc, 'jpg');

  return (
    <Typography component="div" variant="body1" sx={{ my: [2, 3] }}>
      {formatMessage(seoimageLinkMessages.label, {
        link: (
          <Link
            href={`${imgSrc}/${slug}.${imageExtension}`}
            title={productName}
            sx={{ color: 'inherit', textDecorationColor: 'inherit' }}
          >
            {productName}
          </Link>
        ),
      })}
    </Typography>
  );
};
